<div class="modal-header">
  <h5 class="modal-title">Update user</h5>
  <button type="button" class="btn btn-link close pull-right" aria-label="Close" (click)="close()">
    <i class="fa fa-lg fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-24 ps-2 pb-2">
        <label>Application accesses</label>
        <ng-select [items]="groups" formControlName="accesses" [multiple]="true" [closeOnSelect]="false"></ng-select>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="submit()" [disabled]="form.invalid">
    <i class="fa fa-lg fa-plus-circle"></i>Submit
  </button>
  <button class="btn btn-outline-primary" (click)="close()">
    Close
  </button>
</div>
